'use strict';
var validator = require('../validator'),
	dialog = require('../dialog'),
	giftcard = require('../giftcard'),
	TPromise = require('promise'),
	linchpin = require('int_googletagmanager/linchpin/account'),
	linchpinError = require('int_googletagmanager/linchpin/error'),
	billingAddressHelper = require('../billingaddresshelper'),
	util = require('../util');

const isSAEmbedded = $('#add-card').data('embedded');
var secureAcceptance = null;
if (isSAEmbedded) {
	secureAcceptance = require('int_cybersource/secureacceptanceembedded');
} else {
	secureAcceptance = require('int_cybersource/secureacceptance');
}

var $validationContainer = $('.tc-credit-cart-address-validation');

function initializeEvents () {
	initSavedCardRemoval();

	$('#add-card').attr('href', $('#add-card').data('href')).on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				buttons:[],
				dialogClass:'pay-with-card no-title yes-and-no-dialog yes-and-no-dialog-v2',
				open: function () {
					var $self = $(this);
					if (document.activeElement) {
						$(document.activeElement).blur();
					}
					setTimeout(function () {
						const $formSA = $('#secure-acceptance-form');
						var params = {
							'addNewCard': true
						};
						secureAcceptance.init(params);
						validator.initForm($formSA);

						let initalBillingAddressSerialize = '';
						$('#show-edit-addressy', $formSA).on('click',function (e) {
							e.preventDefault();
							$('.customers-address').addClass('disabled');
							$('.billing-edit-address').removeClass('disabled');
							initalBillingAddressSerialize = $formSA.find(':input:not([type="hidden"])').serialize();
							$.uniform.update();
						});
						$('.billing-edit-address .edit-adressy', $formSA).on('click', function (e) {
							e.preventDefault();
							$('.billing-edit-address').addClass('disabled');
							$('.customers-address').removeClass('disabled');
						});

						$('#update-adressy', $formSA).on('click',function (e) {
							e.preventDefault();
							let updatedBillingAddressSerialize = $formSA.find(':input:not([type="hidden"])').serialize();
							let hasChanges = updatedBillingAddressSerialize !== initalBillingAddressSerialize;
							$('.billing-edit-address').addClass('disabled');
							$('.customers-address').removeClass('disabled');
							if (!hasChanges) {
								return;
							}
							billingAddressHelper.updateCompletedBillingAddress();
							secureAcceptance.init({
								'reinit': true,
								'addNewCard': true
							});
						});
						$('.ui-dialog-buttonset .cancel').click(function (e) {
							e.preventDefault();
							$self.dialog('close');
						});
					}, 40);
				}
			}
		});
	});

	// Init event for gift card check balance form in the wallet
	giftcard.initGiftCardCheckBalance();

	// Validate billing address for TC credit cards
	validateBillingAddress();

	// GTM Linchpin analytics
	var walletError = $('.wallet-action-status.error-msg:visible');
	if (SitePreferences.GTM_ENABLED && walletError.length) {
		linchpinError.formErrorEventSingle([walletError], walletError, 'Credit Card Fields');
	}
}
/**
 * @private
 * @desc constructs delete saved card confirmation action
 */
function confirmDelete () {
	return new TPromise(function (resolve, reject) {
		dialog.open({
			html: $('<p>' + Resources.REMOVE_CARD_MSG + '</p>'),
			options: {
				title: Resources.REMOVE_CARD,
				dialogClass: 'yes-and-no-dialog',
				buttons: [
					{
						text: Resources.NO,
						click: function () {
							reject();
							dialog.close();
						},
						'class':'button-gray'
					},
					{
						text: Resources.YES,
						click: function () {
							dialog.close();
							resolve();
						},
						'class':'button-black'
					}
				]
			}
		});
	});
}

/**
 * @function
 * @description validates billing address for TC credit cards
 */
function validateBillingAddress () {
	var $validationForm = $validationContainer.find('.address-form');
	var checkUrl = util.appendParamToURL(Urls.checkAddress, 'AddressID', $validationContainer.data('addressId'));
	$.ajax({
		type: 'POST',
		url: checkUrl,
		data: $validationForm.serialize()
	}).done(function (response) {
		$validationContainer.data('isValid', response.success);
	});
}

function initSavedCardRemoval() {

	// handle card removal button across pages
	$('.delete-card').on('click', function (e) {
		e.preventDefault();
		$('.wallet-action-status').hide().text('');

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.savedCardsRemoveCardEvent(e);
		}

		var removeUrl = util.appendParamToURL(Urls.paymentRemove, 'cardUUID', $(this).data('uuid'));
		confirmDelete().then(function () {
			$.ajax({
				method: 'POST',
				url: removeUrl,
				dataType: 'json'
			}).done(function (response) {
				// display error message
				if (response.error) {
					var errorMessage = response.message || Resources.ERROR_GENERAL;
					$('.wallet-action-status').first().text(errorMessage).show();
					// scroll top to see message on mobile
					$('.wallet-action-status').get(0).scrollIntoView();
				} else {
					// refresh a page
					window.location.reload();
				}
			});
		});
	});
}

module.exports = {
	init: initializeEvents,
	initSavedCardRemoval: initSavedCardRemoval
};
